<template>
  <div class="d-block" v-if="modalShow">
    <v-dialog
      v-model="modalShow"
      class="modalBranch"
      ref="modalBranch"
      data-test="reward-modal-select-branch"
      hide-header
      hide-footer
      centered
      body-class="p-0"
    >
      <div>
        <div
          class="modal-confirm-custom text-center title f-xl"
          data-lang="branch_select_coupon"
        >
          {{ $t("branch_select_coupon") }}
        </div>
        <v-row>
          <v-col>
            <InputSelect
              v-model:value="selected"
              data-test="reward-modal-select-branch-select"
              :options="
                selectedBranchList?.length > 0 ? selectedBranchList : branch
              "
              @change="selectBranch"
              :placeholder="$t('branch_select_coupon')"
              value-field="id"
              text-field="name"
              :isValidate="errorSelectBranch"
            >
              <template v-slot:prepend-item>
                <v-list-item :value="null" disabled
                  >--- {{ $t("branch_select_coupon") }} --</v-list-item
                >
              </template>
            </InputSelect>
            <div class="text-error" v-if="errorSelectBranch">
              {{ $t("branch_select_coupon") }}
            </div>
          </v-col>
        </v-row>
      </div>
      <hr />
      <div class="text-center">
        <c-btn
          @click="confirm"
          :disabled="isDisable"
          variant="confirm-primary"
          block
          data-test="reward-modal-select-branch-confirm-btn"
          >{{ $t("confirm") }}</c-btn
        >
        <c-btn
          v-if="lineLayout == 'Compact'"
          block
          class="mt-2"
          @click="(modalShow = false), (selected = null)"
          variant="outline-primary"
          data-test="reward-modal-select-branch-cancel-btn"
        >
          {{ $t("cancel") }}
        </c-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      required: false,
      type: Object
    },
    branch: {
      required: true,
      type: Array
    },
    redeemQty: { required: false },
    randomReward: { required: false, default: false }
  },
  data() {
    return {
      modalShow: false,
      selected: null,
      body: {
        branch_id: 0,
        redeem_id: 0,
        redeem_type_id: 0,
        product_id: 0,
        redeem_count: 1
      },
      isDisable: true,
      errorSelectBranch: false,
      selectedBranchList: []
    };
  },
  methods: {
    show() {
      this.selected = null;
      this.isDisable = true;
      this.modalShow = true;
      this.errorSelectBranch = false;

      if (this.$store.state.shortProfile.customer_branch_id?.length > 0) {
        this.selectedBranchList =
          this.$store.state.shortProfile.customer_branch_id;
      }
    },
    close(val) {
      if (val === 1) {
        this.$emit("success", this.msg);
      } else {
        this.$emit("error", this.msg);
      }
      this.modalShow = false;
    },
    selectBranch(evt) {
      if (evt) {
        this.errorSelectBranch = false;
        this.isDisable = false;
        return;
      }
      this.$emit("onBranchChange", evt);
    },
    confirm() {
      this.$emit("showPointUsedModal", this.selected);
    },
    async redeemRandomReward() {
      let payload = {
        id: 0, //case ที่ใช้ id คือ case หน้า admin นะ
        random_reward_order_status: parseInt(
          this.detail.random_reward_order_status
        ),
        branch_id: this.selected ? this.selected : this.branch[0].id,
        home_address: "",
        district: "",
        subdistrict: "",
        pick_up_type: parseInt(this.detail.pick_up_type),
        province: "",
        zip_code: "",
        note: "",
        list_order_id: this.$route.params.id // ถ้า edit เป็น list card ก็ใส่มา ถ้าจะ edit รายเดี่ยวก็ใช้ id เหมือนเดิม (case ที่ใช้ id คือ case หน้า admin นะ)
      };
      this.$emit("showLoading");

      const resp = await this.$axios.post(
        `/api/RandomReward/edit_order`,
        payload
      );
      this.$emit("hideLoading");
      if (resp.result) {
        this.msg = this.$t("reward_redeem_success");
        this.close(1);
      } else {
        this.msg = resp.message;
        this.close(2);
      }
    },
    async confirmRedeem() {
      try {
        if (this.randomReward) {
          return this.redeemRandomReward();
        }
        this.body.redeem_id = this.detail.redeem_id;
        this.body.product_id = this.detail.product_id;
        this.body.redeem_type_id = this.detail.redeem_type_id;
        this.body.stock_branch_id = this.detail.stock_branch_id || 0;
        this.body.redeem_count = this.redeemQty;
        if (this.detail.pick_up_type_id == 3) {
          this.body.branch_id = 0;
        } else {
          this.body.branch_id = this.selected
            ? this.selected
            : this.branch
            ? this.branch[0].id
            : 0;
        }

        // console.log(o);
        if (this.detail.is_redeem == 0 && this.$route.query.page == "history") {
          this.onConfirm(this.selected);
        } else {
          this.$emit("showLoading");
          this.isDisable = true;
          this.$axios
            .post(`/api/v1/redeem/redeem_item`, this.body)
            .then(data => {
              this.$emit("hideLoading");
              this.isLoading = false;
              if (data.result == 1) {
                this.msg = data.detail;
                this.close(1);
              } else {
                this.isDisable = false;
                this.msg = data.detail;
                this.close(2);
              }
            })
            .catch(er => {
              this.$emit("hideLoading");
              this.isLoading = false;
              this.isDisable = false;
              this.msg = er.message;
              this.close(2);
              this.$logger({
                response: {
                  config: {
                    url: "/api/v1/redeem/redeem_item",
                    methods: "POST",
                    data: JSON.stringify({
                      payload: this.body,
                      branch: this.branch
                    })
                  }
                },
                action: {
                  action: "redeem reward error",
                  id: 3,
                  note: er.message
                }
              });
            });
        }
      } catch (error) {
        this.$emit("hideLoading");
        this.isLoading = false;
        this.isDisable = false;
        this.msg = error.message;
        this.close(2);
        this.$logger({
          response: {
            config: {
              url: "/api/v1/redeem/redeem_item",
              methods: "POST",
              data: JSON.stringify({ payload: this.body, branch: this.branch })
            }
          },
          action: { action: "redeem reward error", id: 3, note: error.message }
        });
      }
    },
    async onConfirm(branchId) {
      try {
        this.$emit("showLoading");
        const res = await this.$axios.post(
          `/api/v1/Reward/redeem_coupon/${branchId}`,
          this.detail
        );
        this.$emit("hideLoading");
        if (!res.result) {
          this.$emit("error", res.message);
        } else {
          this.$emit("success", res.message);
        }
      } catch (error) {
        this.$emit("hideLoading");
        console.log(error);
        this.$emit("error", error.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  padding: 15px 0;
}
::v-deep .btn-secondary:hover {
  color: #fff;
  background-color: #000000;
  border-color: #000000;
}
</style>
